import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  clothSize: attr('string'),
  clothColors: attr('array')
}).reopenClass({
  _modelNameForMigration: 'thingy'
});